/** @param {string} url */
export const formatWebsite = (url) => {
  if (url) {
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    const httpRegex = /^http:\/\//i;
    if (httpRegex.test(url)) {
      return url.replace(httpRegex, 'https://');
    }
  }
  return url;
};
